









































import { Prop, Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
const loginerModule = namespace('loginer')
const validateUserName = (rule: any, value: any, callback: any): void => {
	if (!value) {
		callback(new Error('请输入用户名'))
	} else {
		callback()
	}
}
const validatePassword = (rule: any, value: any, callback: any): void => {
	if (!value) {
		callback(new Error('请输入密码'))
	} else {
		callback()
	}
}
@Component
export default class LoginForm extends Vue {
	@loginerModule.State('loginerUserName') private loginerUserName?: string
	@Prop ({
		type: Boolean,
		default: true
	}) private logoFlag!: boolean
	private ruleForm: {
		userName: string | undefined,
		password: string | undefined
	} = {
		userName: '',
		password: ''
	}
	private rules: object = {
		userName: [{ validator: validateUserName, trigger: 'blur' }],
		password: [{ validator: validatePassword, trigger: 'blur' }]
	}
	private created () {
		this.ruleForm.userName = this.loginerUserName
	}
	private onLoginClick (ruleForm: string): void {
		(this.$refs[ruleForm] as any).validate().then((valid: any) => {
			this.$emit('on-login', this.ruleForm)
		})
	}
	private onCellInputEnter (arg: any, prop: string): void {
		if (prop === 'submit') {
			this.onLoginClick('ruleForm')
		} else {
			(this.$refs[prop] as any).focus()
		}
	}
	private onRegisterClick (): void {
		this.$emit('on-register-click')
	}
	private onForgotPasswordClick (): void {
		this.$emit('on-forgotPassword-click')
	}
}
